import React, { useState } from 'react';
import styles from './InfoTooltipWithTitleOnModal.module.scss';
import { ReactComponent as IconClose } from '../../../../assets//icons/u_multiply.svg';

type Props = {
  title: string;
  message: string;
  trigger?: 'hover' | 'click';
  position?: 'top' | 'bottom' | 'left' | 'right';
};

export const InfoTooltipWithTitleOnModal = ({
  title,
  message,
  trigger = 'hover',
  position = 'bottom',
}: Props) => {
  const [open, setOpen] = useState(false);

  const handleIconClick = () => {
    if (trigger === 'click') setOpen((prev) => !prev);
  };

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen(false);
  };

  return (
    <div className={styles.helpTooltipContainer}>
      <div
        className={`${styles.tooltip} ${trigger === 'click' ? styles.click : ''}`}
        onClick={handleIconClick}
        style={trigger === 'click' ? { cursor: 'pointer' } : {}}
      >
        <span className={styles.supervisionPlanInfoTooltip} />
        <div
          className={[
            styles.tooltiptext,
            styles[position],
            open ? styles.visible : '',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          <div>
            {title && (<h3 style={{ marginBottom: 15 }}>{title}</h3>)}
            <p>{message}</p>
          </div>
          {trigger === 'click' && (
            <button
              className={styles.closeButton}
              onClick={handleClose}
              style={{
                position: 'absolute',
                top: 5,
                right: -5,
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: 18,
                color: '#888',
              }}
              aria-label="Close"
            >
              <IconClose />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
